<template>
    <!-- <AppBar :show=true></AppBar>
    <NavigationDrawer :show=true></NavigationDrawer> -->

    <v-container v-if="showData" fluid class="bg-background ma-0 pa-4">
    </v-container>
    <v-container v-else fluid class="bg-background ma-0 pa-4">
        <v-row class="ma-0 pa-2">
            <v-btn class="ma-0 mr-2" color="secondary" size="x-small" @click="back" icon="mdi-chevron-left">
            </v-btn>
            <v-col class="ma-0 pa-0">
                <v-icon icon="mdi-bookshelf" color="primary" class="ml-2 mb-1"></v-icon>
                <span class="ml-2 text-h6 mt-6">{{ currentTestForHomeworkReport.title }}</span>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-container fluid class="mt-4 ma-0 pa-0 mr-5">

            <div class="mx-4">
                <v-row>
                    <v-col class="t-h5" cols="auto">
                        {{ currentTestForHomeworkReport.testData.testName }} | Reports
                    </v-col>
                </v-row>


                <div v-if="reportSuccess == false && reportError != null && reportError.length > 0"
                    class=" div-center t-h5Reg">
                    <v-row class="align-center" justify="center">
                        <v-col cols="12">

                            <v-container>
                                {{ reportError }}

                            </v-container>
                        </v-col>
                    </v-row>

                </div>
                <v-row v-for="item in testReports" :key="item">
                    <v-col cols="12">
                        <v-hover v-slot="{ isHovering, props }">

                            <v-card elevation=0 :class="{ 'on-hover': isHovering }" class="px-4 py-1 testCard"
                                v-bind="props">

                                <v-card-text class="">
                                    <v-row dense justify="space-between" class="align-center">
                                        <v-col class="mt-5" cols="12" xs="12" sm="6" md="5" lg="4">
                                            <v-row dense class="align-center ma-0 pa-0 mb-2">
                                                <v-col class="t-h6Reg pa-0 mr-2" cols="auto">
                                                    Attempted Date
                                                </v-col>
                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.testInstanceMode == 'onlinetest' ?
                                                        getDateFromTimeStamp(item.startTimeStamp) : '--' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Test Mode
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    <span
                                                        v-if="item.testInstanceMode == 'onlinetest' && item.mode.toLowerCase() == 'practice'">
                                                        Practice
                                                    </span>
                                                    <span v-else-if="item.testInstanceMode == 'onlinetest'">
                                                        Online
                                                    </span>
                                                    <span v-else-if="item.testInstanceMode == 'offlinetest'">
                                                        Offline
                                                    </span>
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Status
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.status }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Time Spent
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.testInstanceMode == 'onlinetest' ? item.timespentInMinutes +
                                                        ' Mins'
                                                        : '--' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    No. of Question
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.totalQuestion }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Attempted
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.attemptedQuestions }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Correct Questions
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.correctQuestions }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Incorrect Questions
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.incorrectQuestion }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Total Marks
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.marks }}/{{ item.totalTestMarks }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4"
                                            v-if="testReport.testMode == 'onlineoffline' && item.testInstanceMode == 'onlinetest'">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    <span v-if="item.mode == 'Test'">
                                                        Online Rank
                                                    </span>
                                                    <span v-else>
                                                        Online Reference Rank
                                                    </span>
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.onlineRank || '--' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4"
                                            v-if="testReport.testMode == 'onlineoffline' && item.testInstanceMode == 'offlinetest'">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    <span v-if="item.mode == 'Test'">
                                                        Offline Rank
                                                    </span>
                                                    <span v-else>
                                                        Offline Reference Rank
                                                    </span>
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.offlineRank || '--' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4"
                                            v-if="testReport.testMode == 'onlineoffline' && item.testInstanceMode == 'offlinetest'">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Offline Percentile
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.offlineRank ? item.offlinePercentile : '--' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4"
                                            v-if="testReport.testMode == 'onlineoffline' && item.testInstanceMode == 'onlinetest'">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Online Percentile
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.onlineRank ? item.onlinePercentile : '--' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4"
                                            v-if="testReport.testMode == 'onlineoffline'">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    <span v-if="item.mode == 'Test'">
                                                        Combined Rank
                                                    </span>
                                                    <span v-else>
                                                        Combined Reference Rank
                                                    </span>
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.combinedRank || '--' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4"
                                            v-if="testReport.testMode == 'onlineoffline'">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Combined Percentile
                                                </v-col>

                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.combinedRank ? item.combinedPercentile : '--' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4"
                                            v-if="testReport.testMode == 'online'">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    <span v-if="item.mode == 'Test'">
                                                        Rank
                                                    </span>
                                                    <span v-else>
                                                        Reference Rank
                                                    </span>
                                                </v-col>


                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.rank || '--' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>


                                        <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4"
                                            v-if="testReport.testMode == 'online'">
                                            <v-row dense class="align-center ma-0 pa-0  mb-2">
                                                <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                                                    Percentile
                                                </v-col>


                                            </v-row>

                                            <v-row dense class="ma-0 pa-0">
                                                <v-col class="t-h6 ma-0 pa-0" cols="auto">
                                                    {{ item.rank ? item.percentile : '--' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col class="mt-5" cols="12" xs="12" sm="6" md="5" lg="4">
                                            <v-btn class="btn-rd  text-capitalize  t-btnSmall"
                                                @click="viewSolution(item)" color="primary" elevation="0">
                                                View Solutions

                                            </v-btn>

                                        </v-col>
                                        <v-col class="mt-5" cols="12" xs="12" sm="6" md="5" lg="4">
                                            <v-btn v-if="item.subjectWiseReports.length > 0"
                                                class="btn-rd  text-capitalize  t-btnSmall subject-report-btn"
                                                @click="all" color="primary" variant="outlined" rounded="0"
                                                elevation="0">
                                                {{ isDropdownVisible
                                                    ? "Hide Subject-Wise Reports"
                                                    : "Show Subject-Wise Reports" }}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <div class="dropdown-subjectwise-marks" v-if="isDropdownVisible">
                                    <v-data-table :headers="headers" :items="item.subjectWiseReports"
                                        class="elevation-1" item-key="name"> <template v-slot:bottom>
                                            <div></div>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-card>
                        </v-hover>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from 'moment'
import { AnalyticsEvents, recordAnalyticsEvent } from "@/services/awsPinpointAnalyticsService";
// import NavigationDrawer from "../appNavigation/NavigationDrawer.vue";
// import AppBar from "../appNavigation/AppBar.vue";

export default {
    name: 'HomeworkResultsPage',
    async created() {
        this.$store.commit('appbarVisible', true);
        this.$store.commit('navbarVisible', true);
        //const to = this.$route
        //console.log("route changed", to);

        //console.log("test data", this.currentTestForHomeworkReport.testData);

        if (this.currentTestForHomeworkReport.testData === undefined) {
            this.$router.push("/homework");
            recordAnalyticsEvent(AnalyticsEvents.v2HomeworkResultPageLoadedWithoutTestId, {
                success: false,
                message: "Homework test data not present"
            });
        } else {
            recordAnalyticsEvent(AnalyticsEvents.v2HomeworkResultPageLoaded, {
                homeworkTaskId: this.currentTestForHomeworkReport.homeworkTaskId,
                homeworkTestId: this.currentTestForHomeworkReport.testData.testId,
            });
            this.$store.commit('loading', true)
            this.showData = true
            await this.getTestReportsFromServer(this.currentTestForHomeworkReport.testData);
            this.$store.commit('loading', false)
            this.showData = false
        }
    },
    data: () => ({
        tab: 0,
        searchText: '',
        filterSearchVal: '',
        currentTab: {},
        syllabusDialog: false,
        currentParentNodeId: null,
        currentParentType: null,
        group: null,
        currentTests: [],
        testType: "",
        testNodesBreadcrumbs: [],
        testReports: [],
        testReport: {},
        currentCollectionId: "",
        currentCollection: {},
        reportError: "",
        showData: true,
        reportSuccess: false,
        panel: [],
        isDropdownVisible: false,
        viewSolutionClicked: false,
        headers: [
            {
                title: 'Subjects',
                align: 'start',
                sortable: false,
                key: 'subjectName',
            },
            { title: 'Total Questions', align: 'end', key: 'totalQuestions' },
            { title: 'Correct Questions', align: 'end', key: 'correctQuestions' },
            { title: 'Incorrect Questions', align: 'end', key: 'incorrectQuestion' },
            { title: 'Skipped Questions', align: 'end', key: 'skippedQuestions' },
            { title: 'Marks Obtained', align: 'end', key: 'marks' },
            { title: 'Combined Rank', align: 'end', key: 'rank' },
            { title: 'Percentage Score', align: 'end', key: 'percentage' },
            { title: 'Combined Percentile', align: 'end', key: 'percentile' },
            { title: 'Total Marks', align: 'end', key: 'totalSubjectMarks' },
            { title: 'Topper Marks', align: 'end', key: 'topperMarks' },
        ],
    }),

    computed: {
        ...mapState(["currentTestForHomeworkReport"]),
    },
    watch: {

    },
    beforeUnmount() {
        //console.log("unmounted");
        //console.log(this.viewSolutionClicked);
        if (!this.viewSolutionClicked) {
            this.$store.commit("removeTestFromStateHomework");
        }
    },
    methods: {

        all() {
            console.log(this.isDropdownVisible)
            if (this.isDropdownVisible) {
                this.isDropdownVisible = false;
            } else {
                this.isDropdownVisible = true;
            }
        },
        async getTestReportsFromServer(item) {
            recordAnalyticsEvent(AnalyticsEvents.v2HomeworkTestReportsOpen, { homeworkTaskId: this.currentTestForHomeworkReport.homeworkTaskId, testId: item.testId, testName: item.testName });

            this.reportError = ""
            this.$store.commit("clearTestReports")
            this.$store.commit("testReportsLoadedFromServer", false)
            await this.getTestReport(item)
            let report = this.$store.state.testReports
            this.testReport = report
            this.testReports = report.report ?? []
            //console.log(this.testReports)
            this.reportSuccess = report.success ?? false
            let resultAvailable = report.resultAvailable
            let resultTestTime = report.resultTimestamp
            if (this.reportSuccess == false) {
                if (resultAvailable == false) {
                    this.reportError = `Your Result will be declared on ${this.getDateTimeFromTimeStamp(resultTestTime)}`
                }
                else {
                    this.reportError = this.$store.state.testReports.errorMessage
                }
            }
        },
        async getTestReport(item) {
            // console.log("report");
            this.$store.commit("testReportsLoadedFromServer", false)
            await this.$store.dispatch("loadTestReports", item)
        },
        back() {
            recordAnalyticsEvent(AnalyticsEvents.v2HomeworkTestReportBackButtonClicked, { homeworkTaskId: this.currentTestForHomeworkReport.homeworkTaskId, testId: this.currentTestForHomeworkReport.testData.testId, testName: this.currentTestForHomeworkReport.testData.testName });
            this.$router.push(`/homework`);
        },
        getDateTimeFromTimeStamp(timestamp) {
            let date = new Date(timestamp);
            var dateString = moment(date).format("D MMM  YYYY	hh:mm A	");
            return dateString

        },

        getDateFromTimeStamp(timestamp) {
            let date = new Date(timestamp);
            var dateString = moment(date).format("D MMM  YYYY 	hh:mm A	");
            return dateString

        },
        getTestReportDuration(item) {
            let duration = item.completedTimeStamp - item.startTimeStamp
            duration = Math.round((duration / 1000) / 60);
            return duration
        },
        viewSolution(item) {
            recordAnalyticsEvent(AnalyticsEvents.v2HomeworkTestReportViewSolutionClicked, { homeworkTaskId: this.currentTestForHomeworkReport.homeworkTaskId, testId: this.currentTestForHomeworkReport.testData.testId, testName: this.currentTestForHomeworkReport.testData.testName });
            this.viewSolutionClicked = true;
            this.$router.push(`/testresult/${item.testId}?instance=${item.testInstanceId}`)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search-box {
    max-width: 500px;
    margin-right: 30px;
}

.active {
    background: rgb(var(--v-theme-primary)) !important;
    color: white;

}

.dropdown-subjectwise-marks {
    padding: 5px 10px 15px 10px !important;
}

.non-active {
    background: #F3F2F3;

}

.subject-report-btn {
    width: 200px;
}

.v-tab {
    text-transform: none !important;
    text-transform: capitalize !important;
}


.nav-margin {
    margin-left: 0;
}


v-tab:hover {
    background-color: transparent !important;
    background-color: green !important;
    ;
}

.v-sheet.on-hover {
    cursor: pointer;
    /* border: 1px solid rgb(var(--v-theme-primary)); */
    border-color: transparent;
    background-color: white;
    box-shadow: 0px 2px 8px rgba(112, 144, 240, 0.2) !important;
}

.v-card.on-hover {
    /* border: 1px solid rgb(var(--v-theme-primary)); */
    border-color: transparent;
    background-color: white;
    box-shadow: 0px 2px 8px rgba(112, 144, 240, 0.2) !important;

}


.bx {
    background-color: rgb(var(--v-theme-navColor));
    border: 1px solid #E7E7E7;
    border-radius: 4px;
}



.testCard {
    box-shadow: 0px 2px 16px rgba(15, 27, 38, 0.1);
    border-radius: 12px;
    background-color: rgb(var(--v-theme-navColor));
    border: 1px solid #E7E7E7;
}

.div-center {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 100vw;
    text-align: center;
}

.btn-rd {
    border-radius: 8px;
}

.htmlClass {
    color: black;
    font-family: 'Inter', sans-serif;
}

.t-btnSmall {
    font-family: 'Inter', sans-serif !important;
    font-size: 0.7rem !important;
    font-style: normal !important;
    font-weight: 500 !important;
}

.testTabSelected {
    font-family: 'Inter', sans-serif !important;
    color: white !important;
    font-size: 0.875rem !important;
    font-style: normal !important;
    font-weight: 500 !important;

}

.testTab {
    font-family: 'Inter', sans-serif !important;
    font-size: 0.875rem !important;
    font-style: normal !important;
    font-weight: 500 !important;
    color: #323232 !important;
}

.subject-chip {
    font-family: 'Inter', sans-serif !important;
    font-size: 0.65rem !important;
    font-style: normal !important;
    font-weight: 500 !important;
    color: black !important;

}
</style>